"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListItemText2 = _interopRequireDefault(require("@mui/material/ListItemText"));
var _CardActions2 = _interopRequireDefault(require("@mui/material/CardActions"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _Collapse2 = _interopRequireDefault(require("@mui/material/Collapse"));
var _List2 = _interopRequireDefault(require("@mui/material/List"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _ListItem2 = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemButton2 = _interopRequireDefault(require("@mui/material/ListItemButton"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _ListItemIcon2 = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _ExpandMore2 = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _ExpandLess2 = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _CardHeader2 = _interopRequireDefault(require("@mui/material/CardHeader"));
var _Train2 = _interopRequireDefault(require("@mui/icons-material/Train"));
var _DirectionsWalk2 = _interopRequireDefault(require("@mui/icons-material/DirectionsWalk"));
var _DirectionsBike2 = _interopRequireDefault(require("@mui/icons-material/DirectionsBike"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _button = require("../button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SectionCard({
  route: {
    sections
  },
  sectionIndex,
  detailsShowed,
  handleDetailsShowed,
  handleHighlight
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    toTime,
    toDistance
  } = (0, _hooks.useUnits)();
  const section = sections[sectionIndex];
  const {
    transportMode,
    direction,
    duration,
    distance
  } = section;
  const instructions = 'instructions' in section && section.instructions.filter(({
    direction
  }) => direction !== 'reachedYourDestination' && direction !== 'takeSharedBike') || undefined;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_Card2.default, null, /*#__PURE__*/_react.default.createElement(_CardHeader2.default, {
    avatar: transportMode === 'bike' ? /*#__PURE__*/_react.default.createElement(_DirectionsBike2.default, {
      color: "primary"
    }) : transportMode === 'pedestrian' ? /*#__PURE__*/_react.default.createElement(_DirectionsWalk2.default, {
      color: "primary"
    }) : /*#__PURE__*/_react.default.createElement(_Train2.default, {
      color: "primary"
    }),
    subheader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, toTime(duration), " \u2022 ", toDistance(distance)),
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.routing.roadmap.via_direction",
      values: {
        direction
      }
    })
  }), (transportMode === 'bike' || transportMode === 'pedestrian') && instructions && instructions.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledActions, null, detailsShowed ? /*#__PURE__*/_react.default.createElement(_button.Button, {
    endIcon: /*#__PURE__*/_react.default.createElement(_ExpandLess2.default, null),
    onClick: () => handleDetailsShowed(false)
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.hide_details"
  })) : /*#__PURE__*/_react.default.createElement(_button.Button, {
    endIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore2.default, null),
    onClick: () => handleDetailsShowed(true)
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.see_details"
  }))), instructions && instructions.length > 0 && /*#__PURE__*/_react.default.createElement(_Collapse2.default, {
    in: detailsShowed
  }, /*#__PURE__*/_react.default.createElement(_List2.default, null, instructions.map(({
    orientation: orientationKey,
    direction: directionKey,
    roadName,
    facility: facilityKey,
    distance,
    geometryIndex
  }, index) => {
    const direction = _models.instructionDirectionsMap[directionKey];
    const {
      labelKey
    } = _models.instructionOrientationsMap[orientationKey];
    const DirectionIcon = direction?.Icon;
    const facility = _models.instructionFacilitiesMap[facilityKey];
    const FacilityIcon = facility?.Icon;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_ListItem2.default, {
      disablePadding: true,
      secondaryAction: facility && FacilityIcon && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
        placement: "left",
        title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
          i18nKey: facility.labelKey
        })
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FacilityIcon, {
        color: "action"
      }))),
      sx: {
        zIndex: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_ListItemButton2.default, {
      onClick: () => handleHighlight?.({
        sectionIndex,
        geometryIndex
      }, true),
      onMouseEnter: () => handleHighlight?.({
        sectionIndex,
        geometryIndex
      }),
      onMouseLeave: () => handleHighlight?.(null),
      sx: {
        minHeight: 64
      }
    }, /*#__PURE__*/_react.default.createElement(_ListItemIcon2.default, null, DirectionIcon && /*#__PURE__*/_react.default.createElement(DirectionIcon, {
      color: "primary"
    })), /*#__PURE__*/_react.default.createElement(StyledListItemText, {
      secondary: direction && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
        variant: "caption"
      }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
        i18nKey: direction.labelKey,
        values: {
          context: roadName || facility ? 'detailed' : '',
          orientation: t(labelKey),
          roadName: roadName || (facility ? t(facility.labelKey).toLowerCase() : '')
        }
      }))
    }))), index < instructions.length - 1 && /*#__PURE__*/_react.default.createElement(DividerWrapper, null, /*#__PURE__*/_react.default.createElement(_Divider2.default, null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      color: "textSecondary",
      variant: "caption"
    }, toDistance(distance || 0)))));
  }))))));
}
const Wrapper = _styledComponents.styled.div`
  margin: 0 0 0 48px;
`;
const StyledActions = (0, _styledComponents.styled)(_CardActions2.default)`
  justify-content: flex-end;
`;
const StyledListItemText = (0, _styledComponents.styled)(_ListItemText2.default)`
  padding-right: 32px;
`;
const DividerWrapper = _styledComponents.styled.div`
  position: relative;

  > div {
    background-color: white;
    left: 0;
    padding: 0 4px 0 16px;
    position: absolute;
    top: -10px;
  }
`;
var _default = exports.default = SectionCard;